var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99609 8.14221C4.99609 8.14221 7.99609 5.14221 7.99609 2.14221C7.99609 5.14221 10.9961 8.14221 13.9961 8.14221C10.9961 8.14221 7.99609 11.1422 7.99609 14.1422C7.99609 11.1422 4.99609 8.14221 1.99609 8.14221Z",
    stroke: "#DDDDEE",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.32812 13.1421C1.88368 13.1421 2.99479 12.031 2.99479 11.4755C2.99479 12.031 4.1059 13.1421 4.66146 13.1421C4.1059 13.1421 2.99479 14.2532 2.99479 14.8088C2.99479 14.2532 1.88368 13.1421 1.32812 13.1421Z",
    stroke: "#DDDDEE",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6641 3.47546C11.3307 3.47546 12.6641 2.14213 12.6641 1.47546C12.6641 2.14213 13.9974 3.47546 14.6641 3.47546C13.9974 3.47546 12.6641 4.8088 12.6641 5.47546C12.6641 4.8088 11.3307 3.47546 10.6641 3.47546Z",
    stroke: "#DDDDEE",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkle);
export default __webpack_public_path__ + "static/media/sparkle.6642199749a3aaaf4c7b2ab75ffd7158.svg";
export { ForwardRef as ReactComponent };